import round from "astrid-helpers/src/round";

export default function getStudioHours(production, user) {
	const totalStudioHours = production.pages
		? round(production.pages / (production.stats?.tempo?.average || user?.stats?.tempo?.average || 0), 1)
		: 0;
	const completedStudioHours = round((production.liveStats?.completedSessionMinutes || 0) / 60, 1);
	const bookedStudioHours = round((production.bookedMinutes || 0) / 60, 1);
	const remainingStudioHours = round(totalStudioHours - (bookedStudioHours + completedStudioHours), 1);

	return { totalStudioHours, completedStudioHours, bookedStudioHours, remainingStudioHours };
}
